export default {
  Like : 'Like',
  Promotion : 'Promotion',
}
